import React, { useLayoutEffect, useRef, useState } from 'react';
import { Button, Link, Text } from '@belong/ui';
import { Popover } from '@reach/popover';
import clsx from 'clsx';

type HoverMenuButtonProps = {
  title: string | React.ReactNode;
  href?: string;
  children: React.ReactNode;
  onClick?: () => void;
  theme?: 'light' | 'dark';
};

export function HoverMenuButton({ title, href, children, onClick, theme = 'light' }: HoverMenuButtonProps) {
  const isDarkTheme = theme === 'dark';
  const [isOverButton, setIsOverButton] = useState(false);
  const [isOverList, setIsOverList] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>();
  const [isTouchInput, setIsTouchInput] = useState<boolean>();
  const button = useRef(null);

  useLayoutEffect(() => {
    if (isOpen && !isOverButton && !isOverList && !isTouchInput) {
      setIsOpen(false);
    } else if (!isOpen && (isOverButton || isOverList) && !isTouchInput) {
      setIsOpen(true);
    }
  }, [isOverButton, isOverList]);

  return (
    <div
      role="button"
      tabIndex={0}
      ref={button}
      onTouchStart={() => setIsTouchInput(true)}
      onMouseEnter={() => setIsOverButton(true)}
      onMouseLeave={() => setIsOverButton(false)}
      className="h-sm flex justify-center"
    >
      {onClick && (
        <Button variant="text" onClick={onClick}>
          {typeof title === 'string' ? (
            <Text variant="p1" fontWeight="semibold" className={clsx(isOpen && 'text-green')}>
              {title}
            </Text>
          ) : (
            <div className={clsx(isOpen && 'text-green')}>{title}</div>
          )}
        </Button>
      )}
      {href && (
        <Link href={href} buttonType={isDarkTheme ? 'light' : 'primary'}>
          {typeof title === 'string' ? (
            <Text variant="p1" fontWeight="semibold" className={clsx(isOpen && 'text-green')}>
              {title}
            </Text>
          ) : (
            <div className={clsx(isOpen && 'text-green')}>{title}</div>
          )}
        </Link>
      )}

      {isOpen && (
        <Popover targetRef={button}>
          <div
            className="bg-white shadow-xl mt-2xs p-sm pl-xs rounded"
            onMouseEnter={() => setIsOverList(true)}
            onMouseLeave={() => setIsOverList(false)}
          >
            {children}
          </div>
        </Popover>
      )}
    </div>
  );
}
